import { alpha, Box, Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { GOAL_CATEGORY_CONFIG } from "web_myplann/Goals/Types/GoalTypes";
import type { GoalCategoryTypeEnum } from "web_myplann/Infrastructure/Api/Api";

type Props = {
	progress: number;
	category: GoalCategoryTypeEnum;
};

export const DashboardGoalProgressRing: FC<Props> = ({
	progress,
	category,
}) => {
	const { palette, dashboard, iconSize } = useTheme();
	const { ringSize, ringStrokeWidth } = dashboard.goalsCard;
	const CategoryIcon = GOAL_CATEGORY_CONFIG[category].icon;

	const center = ringSize / 2;
	const radius = (ringSize - ringStrokeWidth) / 2;
	const circumference = 2 * Math.PI * radius;

	return (
		<Box position="relative" width={ringSize} height={ringSize}>
			<Box
				component="svg"
				width={ringSize}
				height={ringSize}
				aria-hidden
				display="block"
				sx={{ transform: "rotate(-90deg)" }}
			>
				<circle
					cx={center}
					cy={center}
					r={radius}
					fill="none"
					stroke={alpha(palette.darkmodeText.white, 0.3)}
					strokeWidth={ringStrokeWidth}
				/>
				{progress > 0 && (
					<circle
						cx={center}
						cy={center}
						r={radius}
						fill="none"
						stroke={palette.darkmodeText.white}
						strokeWidth={ringStrokeWidth}
						strokeLinecap="round"
						strokeDasharray={circumference}
						strokeDashoffset={circumference * (1 - progress / 100)}
					/>
				)}
			</Box>
			<Stack
				position="absolute"
				alignItems="center"
				justifyContent="center"
				sx={{ inset: 0 }}
			>
				<CategoryIcon
					size={iconSize.md}
					color={palette.darkmodeText.white}
					aria-hidden
				/>
			</Stack>
		</Box>
	);
};
